export default __webpack_public_path__ + "static/media/octopus-sunbathing.1f5d6823.svg";